import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, MenuItem, Select, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import {
  selectFetchStatusEndpointsInterval,
  setFetchStatusEndpointsInterval
} from "~/features/andon/andon.slice";

const intervalOptions = [
  { label: "1 second", value: 1000 },
  { label: "2 seconds", value: 2000 },
  { label: "3 seconds", value: 3000 },
  { label: "4 seconds", value: 4000 },
  { label: "5 seconds", value: 5000 },
  { label: "10 seconds", value: 10000 },
  { label: "30 seconds", value: 30000 },
  { label: "60 seconds", value: 60000 },
  { label: "90 seconds", value: 90000 },
  { label: "2 minutes", value: 120000 },
  { label: "5 minutes", value: 300000 }
];

const presetValues = new Set([0, ...intervalOptions.map((o) => o.value)]);

function formatMs(ms: number): string {
  if (ms < 60000) {
    const s = ms / 1000;
    return s === 1 ? "1 second" : `${s} seconds`;
  }
  const m = ms / 60000;
  return m === 1 ? "1 minute" : `${m} minutes`;
}

export default function FetchWorkstationsControl() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const interval = useAppSelector(selectFetchStatusEndpointsInterval);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        flexShrink: 0,
        gap: 1,
        height: 40,
        whiteSpace: "nowrap"
      }}
    >
      <Typography variant="body2" color="text.secondary" noWrap>
        {t("fetch workstations")}
      </Typography>
      <Tooltip title={t("fetch workstations tooltip")}>
        <InfoOutlinedIcon
          fontSize="small"
          aria-label={t("fetch workstations tooltip")}
          sx={{ color: "text.secondary", cursor: "help" }}
        />
      </Tooltip>
      <Select
        size="small"
        variant="outlined"
        value={interval}
        onChange={(e) =>
          dispatch(setFetchStatusEndpointsInterval(Number(e.target.value)))
        }
        sx={{ width: 120, height: 40 }}
      >
        {!presetValues.has(interval) && (
          <MenuItem value={interval}>{formatMs(interval)}</MenuItem>
        )}
        <MenuItem value={0}>{t("off")}</MenuItem>
        {intervalOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
